<template>
  <el-dialog v-dialogDrag v-loading="loading" title="请假申请（详情）" :visible.sync="dlgVisible" :close-on-click-modal="false"
    :close-on-press-escape="false" width="800px">
    <div>
      <!-- 业务组件 -->
      <ctrl ref="ctrl" />
      <!-- 流程节点 -->
      <applicationFlow ref="applicationFlow" />
    </div>
    <div slot="footer">
      <el-button type="default" size="small" @click="dlgVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import ctrl from "./index";
import leaveService from "@/CommonDP/service/leave-service";
import applicationFlow from "@/CommonDP/pages/components/launchFlow/components/applicationFlow.vue";

export default {
  components: { ctrl, applicationFlow },
  data() {
    return {
      loading: false,
      dlgVisible: false,
      params: {},
      showBotton: false,
      flowNodesEditorVisible: false,
      showStartButtons: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj
    })
  },
  methods: {
    // 接口：约定给框架提供的方法
    openForViewDetail(params) {
      console.debug(params);
      this.params = params;
      this.reset();
      this.dlgVisible = true;
      this.flowNodesEditorVisible = true;
      this.$nextTick(() => {
        this.$refs.applicationFlow.setFlowStatus(this.params.status);
        this.$refs.applicationFlow.queryCCUserIdList();
        this.queryDetail(params);
      });
    },

    reset() {
      this.loading = false;
      this.dlgVisible = false;
      this.showBotton = false;
      this.flowNodesEditorVisible = false;
      this.showStartButtons = false;
    },

    async queryDetail(params) {
      const res = await leaveService.leaveWtihDraftDetail(params.flowInstanceId);
      const data = res.data || {};
      this.$refs.ctrl.setFormData(data.businessData || {});
      this.$refs.applicationFlow.setNodeList(data.nodes || []);
    }
  }
};
</script>

<style>
</style>
